import React, { useMemo } from "react";
import { MessageCircleHeart } from "lucide-react";

/**
 * CirclePromptOfDay — one gentle prompt at the top of Connection so quiet
 * days still bring the circle in. Deterministic by day-of-year so everyone
 * reading the app on the same date sees the same invitation. No form here —
 * the intent is to spark; sharing happens through the usual Post composer.
 */
const PROMPTS = [
  "What did today's ritual quietly teach you?",
  "Which small change from this month are you glad you began?",
  "Where did your body feel most at home this week?",
  "Name one thing your 70-year-old self will thank you for today.",
  "What did you say no to this week that felt like self-care?",
  "Whose steady presence in the circle made a difference lately?",
  "What did you almost skip today — and how did you feel afterward?",
  "Which longevity habit have you stopped counting because it's just… yours now?",
  "What surprised you about your body's response to a recent choice?",
  "Which win here inspired you — and what did you carry from it?",
  "What are you giving yourself permission to stop trying?",
  "Which morning ritual is starting to feel like an anchor?",
  "Where are you being kinder to yourself than you used to be?",
];

function todaysPrompt() {
  const now = new Date();
  const start = new Date(now.getFullYear(), 0, 0);
  const dayOfYear = Math.floor((now - start) / 86_400_000);
  return PROMPTS[dayOfYear % PROMPTS.length];
}

export default function CirclePromptOfDay() {
  const prompt = useMemo(todaysPrompt, []);
  return (
    <section
      className="relative overflow-hidden rounded-md border hairline bg-gradient-to-r from-[hsl(var(--sand))]/60 via-[hsl(var(--paper))] to-[hsl(var(--paper))] p-5 md:p-6"
      data-testid="circle-prompt-of-day"
    >
      <div className="flex items-start gap-4">
        <div
          aria-hidden
          className="shrink-0 grid place-items-center w-10 h-10 rounded-full bg-[hsl(var(--clay))]/15 text-[hsl(var(--clay))]"
        >
          <MessageCircleHeart size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <div className="text-[11px] uppercase tracking-[0.24em] text-[hsl(var(--clay))]">
            Prompt of the day
          </div>
          <p
            className="mt-1.5 font-display text-lg md:text-xl italic leading-snug text-[hsl(var(--fg))]"
            data-testid="circle-prompt-text"
          >
            {prompt}
          </p>
          <p className="mt-2 text-[11px] text-[hsl(var(--muted-foreground))]">
            No pressure. Answer here when it lands, in Journal when it&apos;s only for you.
          </p>
        </div>
      </div>
    </section>
  );
}
